module.exports = __webpack_public_path__ + "img/btn-check.00a93181.png";